export const formatDate = (date: Date) => {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();

    return `${m}/${d}/${y}`;
};

export const formatDateByYearMonthDay = (date: Date) => {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();

    return `${y}-${padNumber(m)}-${padNumber(d)}`;
};

const padNumber = function (num: number) {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? "0" : "") + norm;   
};

export const formatPhoneNumber = (phoneNumberString: string): string => {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, "");
    const matchNoCountry = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    const matchWithCountry = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (matchNoCountry) {
        return `${matchNoCountry[1]}-${matchNoCountry[2]}-${matchNoCountry[3]}`;
    }
    if (matchWithCountry) {
        return `${matchWithCountry[2]}-${matchWithCountry[3]}-${matchWithCountry[4]}`;
    }
    return phoneNumberString;
};

export const getCommaSeparatedDisplayPrice = (price : number | undefined) : string =>{
    if (price === undefined) {return ""}
    return price.toLocaleString('en-US',{minimumFractionDigits:2, maximumFractionDigits:2})
}